import { defineStore } from 'pinia'
import Actions from './actions'
import Getters from './getters'
import { useState } from './state'

export { type FilterState } from './state'

export const useFilterStore = defineStore('filter', {
  state: useState,
  getters: { ...Getters },
  actions: { ...Actions },
})

export type FilterStoreContext = ReturnType<typeof useFilterStore>